import SEmpty from './index.vue';

export {
	  SEmpty,
}

export default SEmpty;